<template>
  <div class="mx-auto mt-10 max-w-7xl flex flex-col">
    <div class=" grid grid-cols-2 items-start gap-x-5">
      <div class="rounded-box p-10">
        <OtherWorkshops />
      </div>

      <!-- this bootcamp vs other bootcamps -->
      <div class="rounded-box bg-green-200 p-10">
        <ThisWorkshop :state="{ vsOtherWorkshops: true }" />
      </div>
    </div>
  </div>
</template>

<script>
import OtherWorkshops from '@/components/comparison/OtherWorkshops.vue'
import ThisWorkshop from '@/components/comparison/ThisWorkshopNonReactive.vue'

export default {
  components: {
    OtherWorkshops,
    ThisWorkshop
  }
}
</script>
